import React from 'react';
import type { ReviewFacts } from './reviewFacts';
import type { ReviewWriteWords } from './reviewWriteWords';

// What a product page's review shows under its card beyond the words the card is designed around, as Shopify's
// review apps show it: the reviewer's voice note or video when the shop attached one, and the shop's reply.

// Draws the review's voice note, video and the shop's reply, or nothing when it has none of them.
export const ReviewExtras: React.FC<{ review: ReviewFacts; words: ReviewWriteWords }> = ({ review, words }) => {
  if (!review.audio && !review.video && !review.reply) return null;
  return (
    <div className="xe-review-extras">
      {review.audio && <audio className="xe-review-audio" src={review.audio} controls preload="metadata" aria-label={words.voiceNote} />}
      {review.video && <video className="xe-review-video" src={review.video} controls preload="metadata" playsInline aria-label={words.video} />}
      {review.reply && (
        <div className="xe-review-reply">
          <p className="xe-review-reply-title">{words.reply}</p>
          <p dir="auto">{review.reply}</p>
        </div>
      )}
    </div>
  );
};
